export default __webpack_public_path__ + "static/media/open-mail-icon.15bf2d47.svg";